import React from 'react';
import { Grid, Card, CardContent, Typography, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import '../../servicestypes/webdevelopment/webdevservices.css'; // Import the CSS file
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';

import Appimage from '../../../assests/app development.jpeg';

const Appdevelopment = () => {
  return (
    <Card className="webdevelopment-card">
      {/* Left side with image */}
      <Grid item xs={12} md={4} className="webdevelopment-image-container">
        <Box
          component="img"
          className="webdevelopment-image"
          alt="App Development"
          src={Appimage}
        />
        
        {/* Contact Information */}
        <div className="contact-info">
          <Typography variant="h6" component="div" gutterBottom className="contact-title">
            Contact Information
          </Typography>
          <div className="contact-item">
            <PhoneIcon className="contact-icon" />
            <Typography variant="body1" className="contact-text">+919060237575</Typography>
          </div>
          <div className="contact-item">
            <EmailIcon className="contact-icon" />
            <Typography variant="body1" className="contact-text">Faridiakram41@gmail.com</Typography>
          </div>
          <div className="contact-item">
            <LocationOnIcon className="contact-icon" />
            <Typography variant="body1" className="contact-text">Samastipur, Bihar (848101)</Typography>
          </div>
        </div>
        
        {/* Back Button */}
        <Link to="/Services">
          <button className="comic-button">Back</button>
        </Link>
      </Grid>
      
      {/* Right side with content */}
      <Grid item xs={12} md={8} className="webdevelopment-content">
        <CardContent>
          <Typography variant="h4" component="div" gutterBottom className="webdevelopment-title">
            App Development
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Native App Development:</strong> Building Android and iOS apps using Swift, Kotlin, or React Native.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Cross-Platform Development:</strong> Creating apps that run on both Android and iOS with React Native or Flutter.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>UI/UX Design for Apps:</strong> Designing user-friendly and visually appealing app interfaces.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Backend Development for Apps:</strong> Implementing server-side logic and database management for apps.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>App Maintenance and Updates:</strong> Providing regular updates and fixes to ensure app functionality.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Push Notification Services:</strong> Integrating push notifications for user engagement.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>App Store Optimization (ASO):</strong> Improving app visibility on app stores.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Security Features:</strong> Implementing secure authentication, encryption, and data protection.
          </Typography>
        </CardContent>
      </Grid>
    </Card>
  );
};

export default Appdevelopment;
